import React from 'react';

import SecondCopyModal, {
  DocumentFormat,
} from 'pages/shared/components/SecondCopyModal';

export type DownloadModalProps = {
  open: boolean;
  invoiceNumber?: string | number;
  itemCount: number;
  totalAmount: string;
  loading?: boolean;
  format?: DocumentFormat;
  onClose: () => void;
  onSubmit: () => void;
  onFormatChange?: (format: DocumentFormat) => void;
};

const DownloadModal = ({
  open,
  invoiceNumber,
  itemCount,
  totalAmount,
  loading = false,
  format = 'PDF',
  onClose,
  onSubmit,
  onFormatChange,
}: DownloadModalProps): JSX.Element => {
  const description =
    itemCount === 1 ? (
      <>
        Será baixada a 2ª via da{' '}
        <strong>Nota fiscal {invoiceNumber ?? '-'}</strong>.
      </>
    ) : (
      <>
        Serão baixadas as 2ª vias das{' '}
        <strong>{itemCount} notas fiscais selecionadas</strong>.
      </>
    );

  return (
    <SecondCopyModal
      open={open}
      mode="download"
      itemCount={itemCount}
      totalAmount={totalAmount}
      format={format}
      onFormatChange={onFormatChange ?? (() => undefined)}
      loading={loading}
      onClose={onClose}
      onSubmit={onSubmit}
      itemLabelSingular="nota fiscal"
      itemLabelPlural="notas fiscais"
      description={description}
    />
  );
};

export default DownloadModal;
